import { Injectable } from '@angular/core';
import { AngularFireStorage } from '@angular/fire/storage';

@Injectable({
     providedIn: 'root'
})

export class FileService {
     
     constructor(protected angularFireStorage: AngularFireStorage) { }

     public async uploadPdfFile(file: any, collectionName: string, folder: string, id: string) {

          const filePath = this.getFilePath(folder, id);
          const metadata : any = { 
               contentType: 'application/pdf', 
               cacheControl: 'public,max-age=3000000', 
               collectionName,
               id 
          };
          const fileRef = this.angularFireStorage.ref(filePath);
          await fileRef.put(file, metadata);
          
          return fileRef.getDownloadURL();
     }

     private getFilePath(folder: string, id: string): string {
          const ts = new Date().toISOString();
          const filePath = `${folder}/${id}/${ts}.pdf`;
          return filePath;
      }
}